import {useEffect, useLayoutEffect} from 'react';
import {isClient} from './helpers';

export const useIsomorphicLayoutEffect: typeof useEffect = (...args) => {
  return isClient() ? useLayoutEffect(...args) : useEffect(...args);
};
